<div class="d-flex step-type-container">
  <div class="step-type">
    <div>{{step.name}}</div>
    <div>({{step.path}})</div>
  </div>
</div>
